export default __webpack_public_path__ + "static/media/10_Livingroom-Interior-Architecture-EschweilerPhotography02.2c7bdb5e.jpg";